import "../css/style.scss"
import { AddPlayButton } from "./modules/AddPlayButton"
import { MobileMenuKeyNav } from "./modules/MobileMenuKeyNav.js"
import { GartnerPi_Aria } from "./modules/GartnerPi_Aria.js"
import { GartnerPi_ClipPaths } from "./modules/GartnerPi_ClipPaths.js"
import { GartnerPi_Carousel } from "./modules/GartnerPi_Carousel.js"
import { GartnerPi_Scroller } from "./modules/GartnerPi_Scroller.js"
import { EmptyAltTags } from "./modules/EmptyAltTags.js"
import { StaticGifConverter } from "./modules/StaticGifConverter.js"
import { TabStopOnCrunchifyCopyLink } from "./modules/TabStopOnCrunchifyCopyLink.js"
import { Jkea_SliderFixes } from "./modules/Jkea_SliderFixes.js"
import { BlogEmailClick } from "./modules/BlogEmailClick.js"

const onReady = () => {
  if (location.hostname === "localhost" || location.hostname.includes("igloo-local.local")) {
    document.body.classList.add("localhost")
  }
  var addPlayButton = new AddPlayButton({
    targetSelector: ".jkea_header__graphic .videoplayer-container .outer_vidyard_wrapper",
  })
  const mobileMenuNav = new MobileMenuKeyNav([{ targetSelector: "nav#mobile", buttonSelector: "#nav-icon" }])
  const gartnerPi_Aria = new GartnerPi_Aria({
    targetSelector: "#peerinsights",
    subtreeReadyIndicator: ".gartner-pi-star-rating",
  })
  const gartnerPi_ClipPaths = new GartnerPi_ClipPaths(".es-carousel-layout-container")
  const gartnerPi_Carousel = new GartnerPi_Carousel({
    containerSelector: '[class^="elfsight-app"]',
    ratingSelector: ".es-rating-container",
    swiperSelector: ".swiper-wrapper",
    swiperInitialized: ".swiper-initialized",
    visibleSelector: ".swiper-slide-visible",
    buttonContainerSelector: ".es-carousel-layout",
    halfStarSelector: ".es-rating-stars-item-unfilled",
    fullStarSelector: ".es-rating-stars-item-filled",
    subtreeReadyIndicator: ".es-rating-bar-container",
    finishedPopulatingReviewsPartialClass: "ArrowControl__ArrowControlContainer",
    reviewsContainerPartialClass: "Carousel__CarouselSwiperWrapper",
  })
  const gartnerPi_Scroller = new GartnerPi_Scroller({
    containerSelector: ".gartner-pi-reviews",
    unitSelector: ".gartner-pi-reviews ul > li",
  })
  const emptyAltTags = new EmptyAltTags()
  const staticGifConverter = new StaticGifConverter()
  const jkea_SliderFixes = new Jkea_SliderFixes()

  let tabStopOnCrunchifyCopyLink = new TabStopOnCrunchifyCopyLink({
    containerSelector: ".crunchify-social",
    linkSelector: ".crunchify-link",
  })
  let blogEmailClick = new BlogEmailClick({
    targetSelector: ".crunchify-social .crunchify-permalink",
  })
}
if (document.readyState !== "loading") {
  onReady()
} else {
  document.addEventListener("DOMContentLoaded", onReady)
}
